module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_9005.bda3dbfd.png";